import React, { Fragment } from "react";
import ContentItem from "./ContentItem";

export default function ContentSection({
  featuredContent,
  onUploadCardClick,
  hex,
  setSelectedContent,
}) {
  const renderCards = (userType) => {
    const uploadCardPlaceholder = null;

    if (userType === "prospect") {
      const prospectContent = [...featuredContent.prospects];
      return prospectContent.length < 4
        ? [...prospectContent, uploadCardPlaceholder]
        : prospectContent;
    } else if (userType === "member") {
      const membersContent = [...featuredContent.members];
      return membersContent.length < 4
        ? [...membersContent, uploadCardPlaceholder]
        : membersContent;
    }
    return [];
  };

  return (
    <Fragment>
      <div>
        <h2 className="featured-content__type-title">Prospect content</h2>
        {renderCards("prospect").map((content, i) => (
          <Fragment key={content ? content.id : i}>
            <ContentItem
              contentItem={content}
              setSelectedContent={setSelectedContent}
              onUploadCardClick={onUploadCardClick}
              hex={hex}
              userType="prospect"
            />
          </Fragment>
        ))}
      </div>

      <div>
        <h2 className="featured-content__type-title">Member content</h2>
        {renderCards("member").map((content, i) => (
          <Fragment key={content ? content.id : i}>
            <ContentItem
              contentItem={content}
              setSelectedContent={setSelectedContent}
              onUploadCardClick={onUploadCardClick}
              hex={hex}
              userType="member"
            />
          </Fragment>
        ))}
      </div>
    </Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/screens/FeaturedContent/components/ContentSection.jsx